import { render, staticRenderFns } from "./UploadFileHD.vue?vue&type=template&id=71f39296&scoped=true&"
import script from "./UploadFileHD.vue?vue&type=script&lang=js&"
export * from "./UploadFileHD.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileHD.vue?vue&type=style&index=0&id=71f39296&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f39296",
  null
  
)

export default component.exports